module.exports = __webpack_public_path__ + "switzerland.svg?7df2574f500bdc0a816dc723fb12b846";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/switzerland.svg
// module id = 311
// module chunks = 10